import React from 'react';
import { withRouter } from 'react-router-dom';

import { FlexContainer, Image, StyledText } from '../StyledComponents';

import facebook from '../../../assets/images/facebook-logo.png';
import twitter from '../../../assets/images/twitter-logo.png';
import copy from '../../../assets/images/copy-logo.png';
// import reddit from '../../../assets/images/reddit-logo.png';
// import email from '../../../assets/images/email-logo.png';
// import linkedin from '../../../assets/images/linkedin-logo.png';

import {
  FacebookShareButton,
  TwitterShareButton
  // WhatsappShareButton,
  // RedditShareButton,
  // EmailShareButton,
  // LinkedinShareButton
} from 'react-share';

const style = {
  fontfamily: 'Nunito',
  fontsize: '1.125rem',
  color: '#484848',
  fontweight: 'normal',
  padding: '0 0 0 9px'
};

const ShareLinks = props => {
  // let copySuccess = '';
  const clickHandler = e => {
    // console.log('props: ', props);
    // let url = `https://beebom.com/${props.match.url}`;
    // console.log('clickHandler');

    // e.preventDefault();
    e.stopPropagation();
  };

  const copyToClipboard = e => {
    e.stopPropagation();
    let copiedText = window.location.href;
    navigator.clipboard.writeText(copiedText).then(
      function() {
        console.log('Async: Copying to clipboard was successful!');
      },
      function(err) {
        console.error('Async: Could not copy text: ', err);
      }
    );
  };

  const shareUrl = `https://beebom.com${props.match.url}`;
  // const shareUrl = `https://beebom.com/oneplus-bullets-wireless-red-india/`;
  // console.log('shareUrl: ', shareUrl);
  const url = `${props.match.url}`;
  const string = url.replace(/\//g, '').replace(/-/g, ' ');
  let firstChar = string.charAt(0).toUpperCase();
  let otherChars = string.slice(1).toLowerCase();
  const title = firstChar + otherChars;

  // const title = 'Yayyy! Here comes your Post Title. Kapil is so cool! :D';
  // console.log('title: ', title);

  return (
    <FlexContainer alignitems="center" className="ml5-l ml2-m ml5-ns">
      <FlexContainer
        alignitems="center"
        className="pa2 ph2-p ph4-l pv2-ns pointer grow"
        onClick={e => clickHandler(e)}
      >
        <FacebookShareButton
          url={shareUrl}
          quote={title}
          className="share-button"
        >
          {/* <FacebookIcon size={32} round /> */}

          <Image src={facebook} width="16px" height="26px" />
          <StyledText className="dn db-l" {...style}>
            Share
          </StyledText>
        </FacebookShareButton>
      </FlexContainer>
      <FlexContainer
        alignitems="center"
        className="pa2 ph2-p ph4-l pv2-ns pointer grow"
        onClick={e => clickHandler(e)}
      >
        <TwitterShareButton
          url={shareUrl}
          title={title}
          className="share-button"
        >
          <Image src={twitter} width="25px" height="19px" />
          <StyledText className="dn db-l" {...style}>
            Tweet
          </StyledText>
        </TwitterShareButton>
      </FlexContainer>

      <FlexContainer
        alignitems="center"
        className="pa2 ph2-p ph4-l pv2-ns pointer grow"
        onClick={e => copyToClipboard(e)}
      >
        <Image src={copy} width="25px" height="25px" />
        <StyledText className="dn db-l" {...style}>
          Copy
        </StyledText>
      </FlexContainer>

      {/* <FlexContainer
        alignitems="center"
        className="pa2 ph2-p ph4-l pv2-ns pointer grow"
        onClick={e => clickHandler(e)}
      >
        <RedditShareButton
          url={shareUrl}
          title={title}
          separator=":: "
          className="share-button"
        >
          <Image src={reddit} width="19px" height="25px" />
          <StyledText className="dn db-l" {...style}>
            Reddit
          </StyledText>
        </RedditShareButton>
      </FlexContainer> */}

      {/* <FlexContainer
        alignitems="center"
        className="pa2 ph2-p ph4-l pv2-ns pointer grow"
        onClick={e => clickHandler(e)}
      >
        <EmailShareButton
          url={shareUrl}
          title={title}
          separator=":: "
          className="share-button"
        >
          <Image src={email} width="25px" height="17px" />
          <StyledText className="dn db-l" {...style}>
            Email
          </StyledText>
        </EmailShareButton>
      </FlexContainer> */}

      {/* <FlexContainer
        alignitems="center"
        className="pa2 ph2-p ph4-l pv2-ns pointer grow"
        onClick={e => clickHandler(e)}
      >
        <LinkedinShareButton
          url={shareUrl}
          title={title}
          windowWidth={750}
          windowHeight={600}
          className="share-button"
        >
          <Image src={linkedin} width="25px" height="25px" />
          <StyledText className="dn db-l" {...style}>
            LinkedIn
          </StyledText>
        </LinkedinShareButton>
      </FlexContainer> */}
    </FlexContainer>
  );
};

export default withRouter(ShareLinks);
